export class GetSchoolWorkspaceSettings {
  static readonly type =
    "[Organization Settings / Workspace Settings] Get School Workspace Settings";
}

export class CheckSchoolProgramPreferencesSettings {
  static readonly type =
    "[Student Preferences] Check School Program Preferences Settings";
}

export class UpdateSchoolWorkspaceSettings {
  static readonly type =
    "[Organization Settings / Workspace Settings] Update School Workspace Settings";
  constructor(public payload: { enableStudentSchedulePreferences: boolean }) {}
}
